import * as React from "react";
import { withRouter } from "react-router-dom";
import MyChartDataTile from "../dashboard/MyChartDataTile";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import MobileNumberInfo from './MobileNumberInfo';
import EmailInfo from './EmailInfo';
import * as Tools from "../../helpers/Tools";
import * as d from "../../reducers/domainReducer";
import { logUI } from "../../api/andyliticsApi";
import SectionLoadingError from "../common/SectionLoadingError";
import { PageHeading } from "../ecosystem/mybswh";


class Demographics extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Demographics.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    handleAdminInfoClick = () => {
        logUI(`MBHWeb.UI.Demographics.AdminInfo.Clicked`, new Date(), Tools.getURLPath());
        this.props.history.push("/admininfo");
    }

    render() {
        const { serverData, hasMyChart, primaryUser, currentMyChartUser, epicEHRDown, isMyChartInActive } = this.props;
        const [proceedMessage, cancelMessage, confirmationModalMessage] = ['Continue', 'Stay On This Page', 'Would you like to leave this page? Changes may be lost if you have not saved them.'];
        const { proxyName } = Tools.getProxyName(primaryUser, currentMyChartUser);

        return (
            <div className="container-fluid body-content personal-info-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <PageHeading heading="Contact Information" proxyName={proxyName} />

                        <EmailInfo />

                        <MobileNumberInfo />

                        {hasMyChart &&
                            <React.Fragment>
                                <div className="row">
                                    <div className="col-12 col-md-10">
                                        <h2 className="page-heading section-heading dt-heading">Medical Records</h2>
                                    </div>
                                </div>
                                <> {!isMyChartInActive && !epicEHRDown ?
                                    <MyChartDataTile mode="demog" title="Medical Records Personal Information" navigation="hide" byroute="false" serverData={serverData}
                                        confirmationModalBtnTxt1={cancelMessage} confirmationModalBtnTxt2={proceedMessage} confirmationModalMsg={confirmationModalMessage} partialView />
                                    : <SectionLoadingError sectionErrorClass="errorSectionClass" message="Not available. Please try again later." />}</>
                           </React.Fragment>
                        }
                    </div>
                </div>
            </div>
        );
    }

};

const mapStateToProps = (state) => {
    return {
        epicEHRDown: state.common.epicEHRDown,
        hasMyChart: state.domain.hm,
        serverData: state.session.serverData,
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        currentMyChartUser: d.hydrateProxyUser(state.domain.cu),
        isMyChartInActive: state.dashboard.isMyChartInActive
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Demographics));
